/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HTTPStatus } from '../../../../../../core/admin/providers/CommonInterceptor';
import { Subscription } from 'rxjs';
import { Globals } from '@constants/globals';


@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html'
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = [];
  public loader = false;


  constructor(
    private httpStatus: HTTPStatus,
    private globals: Globals
    ) {
    this.getHttpResponse();
  }

  ngOnInit(): void {}

  getHttpResponse() {
    this.subscriptions.push(this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
      if (!this.globals.hideGlobalLoaderFlag) {
        this.loader = status;
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(each => each.unsubscribe());
  }
}
